module.exports = __webpack_public_path__ + "static/media/z&v4.87fdbdf7.jpg";